import React, { useState, useEffect } from 'react';
import {
    Modal,
    Box,
    SpaceBetween,
    Button,
    Textarea
} from "@cloudscape-design/components";

interface BugReportModalProps {
    visible: boolean;
    onDismiss: () => void;
    onSubmit: (bugReport: string) => void;
    isSubmitting: boolean;
}

const BugReportModal: React.FC<BugReportModalProps> = ({ visible, onDismiss, onSubmit, isSubmitting }) => {
    const [bugReport, setBugReport] = useState('');

    useEffect(() => {
        if (visible) {
            setBugReport('');
        }
    }, [visible]);

    const handleSubmit = () => {
        onSubmit(bugReport);
    };

    return (
        <Modal
            visible={visible}
            onDismiss={onDismiss}
            header="Submit Bug Report"
            closeAriaLabel="Close bug report modal"
        >
            <Box margin={{ bottom: "l" }}>
                <SpaceBetween direction="vertical" size="l">
                    <Textarea
                        key="bug-report-textarea"
                        onChange={({ detail }) => setBugReport(detail.value)}
                        value={bugReport}
                        placeholder="Please describe the issue you encountered..."
                        rows={5}
                    />
                    <SpaceBetween direction="horizontal" size="xs">
                        <Button 
                            key="cancel-button"
                            onClick={onDismiss} 
                            variant="link"
                        >
                            Cancel
                        </Button>
                        <Button 
                            key="submit-button"
                            onClick={handleSubmit} 
                            variant="primary"
                            disabled={!bugReport.trim() || isSubmitting}
                            loading={isSubmitting}
                        >
                            {isSubmitting ? 'Submitting...' : 'Submit Report'}
                        </Button>
                    </SpaceBetween>
                </SpaceBetween>
            </Box>
        </Modal>
    );
};

export default BugReportModal;
